module.exports = __webpack_public_path__ + "img/sunprotection.13c36bfe.svg";